import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    INewSpecialMonthDay
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/INewSpecialMonthDay";


const useApiGetNewSpecialMonthDay = (pk: number | undefined): UseQueryResult<INewSpecialMonthDay, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<INewSpecialMonthDay> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/new_special_month_day/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetNewSpecialMonthDay", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk
    })
};

export default useApiGetNewSpecialMonthDay